module.exports = __webpack_public_path__ + "static/pic04-31af2c8b761661c29cb5209cf78e9327.jpg";